import { colors } from '@ardoq/design-tokens';
import { SvgImage, SvgImageName } from '@ardoq/icons';
import styled from 'styled-components';
import { BADGE_CONTENT_HEIGHT, BadgeLabel, commonStyling } from './atoms';

const InternalBadgeContainer = styled.div`
  ${commonStyling};
  white-space: nowrap;
  border-color: ${colors.surfaceInverted};
  background-color: ${colors.surfaceInverted};
  color: ${colors.textOnInvertedStrong};
  cursor: default;
`;

// The logo sprite is inset within its viewBox, so it is rendered at the full
// badge height to match the optical size of the icons the other badges use.
const ArdoqLogoIcon = () => (
  <SvgImage
    svgImageName={SvgImageName.INVERTED_ARDOQ_LOGO}
    width={BADGE_CONTENT_HEIGHT}
    height={BADGE_CONTENT_HEIGHT}
  />
);

export const InternalBadge = () => (
  <InternalBadgeContainer role="img" aria-label="Internal">
    <ArdoqLogoIcon />
    <BadgeLabel label="Internal" />
  </InternalBadgeContainer>
);
